/**
 * KAN-721: флажки строки материала оператора: можно отправлять в переписке,
 * прикладывать к письму, основной прайс-лист. Основной прайс один на
 * оператора: бэкенд снимает отметку с остальных, список обновляется после
 * перезапроса.
 */
import type {
  InstructionAttachment,
  UpdateInstructionAttachmentPayload,
} from '@/services/api/instructionAttachments';
import { AttachToEmailCheckbox } from './AttachToEmailCheckbox';
import { MaterialFlagCheckbox } from './MaterialFlagCheckbox';

interface MaterialRowFlagsProps {
  item: InstructionAttachment;
  onUpdate: (data: UpdateInstructionAttachmentPayload) => Promise<unknown>;
}

export function MaterialRowFlags({ item, onUpdate }: MaterialRowFlagsProps): JSX.Element {
  // Ошибку показывает toast в мутации; флажок вернётся к значению с сервера.
  const patch = (data: UpdateInstructionAttachmentPayload) => {
    onUpdate(data).catch(() => undefined);
  };
  const prefix = `attachment-${item.id}`;
  return (
    <div className="space-y-1">
      <MaterialFlagCheckbox
        id={`${prefix}-enabled`}
        label="Можно отправлять в переписке"
        hint="бот и менеджер могут отправить файл клиенту"
        checked={item.enabled}
        ariaLabel={`Можно отправлять в переписке: ${item.title}`}
        onChange={enabled => patch({ enabled })}
      />
      <AttachToEmailCheckbox
        id={`${prefix}-attach-to-email`}
        checked={item.attach_to_email ?? false}
        ariaLabel={`Прикладывать к письму: ${item.title}`}
        onChange={attach_to_email => patch({ attach_to_email })}
      />
      <MaterialFlagCheckbox
        id={`${prefix}-main-price`}
        label="Основной прайс-лист"
        hint="бот отправит его на вопросы о ценах; основной прайс у оператора один"
        checked={item.is_main_price ?? false}
        ariaLabel={`Основной прайс-лист: ${item.title}`}
        onChange={is_main_price => patch({ is_main_price })}
      />
    </div>
  );
}
